import {useState} from 'react'
import useApiStatusEnvAwarePost from '../../hooks/useApiStatusEnvAwarePost'
import Button from 'react-bootstrap/Button'
import Spinner from 'react-bootstrap/Spinner'
import Modal from 'react-bootstrap/Modal'
import GymMultiSelect from '../GymMultiSelect/GymMultiSelect'

const CopyModal = ({show,onHide,muscle_ids})=>{

	const [selectedGyms,setSelectedGyms] = useState([])
	const [copyStatus,setCopyStatus] = useState('idle')
	const statusPost = useApiStatusEnvAwarePost()

	const handleCopy = ()=>{
		const tgt_users = selectedGyms.map(g=>g.value)
		setCopyStatus('pending')
		statusPost(
			'api/exercises/',
			{action:'copyMuscleGroups',tgt_users,muscle_ids},
			'muscle group',
			'copi'
		).then(res=>{
			setSelectedGyms([])
			setCopyStatus('idle')
			onHide()
		})
	}

	return (
		<Modal 
			onHide={onHide}
			show={show}
			centered
		>
			<Modal.Header closeButton>
				Copy Muscle Groups
			</Modal.Header>
			<Modal.Body>
				<GymMultiSelect 
					onChange={setSelectedGyms}
				/>
				<Button 
					disabled={selectedGyms.length === 0 || copyStatus === 'pending'}
					onClick={handleCopy}
					variant="outline-success" 
					className="mt-2"
					block
				>
					Copy {copyStatus==='pending'&&<Spinner animation="border" size="sm"/>}
				</Button>
			</Modal.Body>
		</Modal>
	)
}


export default CopyModal